
    import HeadingSection from '../../components/MainComponent/HeadingSection.vue';
    import Team from '../../components/AboutUs/Team.vue';
    import ProjectsSection from '../../components/MainComponent/ProjectsSection.vue';
    import PageSections from '../../components/AboutUs/PageSections.vue';

    export default {
        head: function () {
            return {
                title: this.$store.state.aboutUsPageData.meta_title || this.$nuxt.$options.head.title,
                meta: [
                    { hid: 'description', name: 'description', content: this.$store.state.aboutUsPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },

                    { hid: 'og:title', property: 'og:title', content: this.$store.state.aboutUsPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'og:description', property: 'og:description', content: this.$store.state.aboutUsPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'og:image', property: 'og:image', content: this.$store.state.aboutUsPageData.background_image },

                    { hid: 'twitter:title', name: 'twitter:title', content: this.$store.state.aboutUsPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'twitter:description', name: 'twitter:description', content: this.$store.state.aboutUsPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'twitter:image', name: 'twitter:image', content: this.$store.state.aboutUsPageData.background_image }
                ],
            };
        },
        components: {
            ProjectsSection,
            Team,
            HeadingSection,
            PageSections,
        },
        computed: {
            aboutUsPageData() {
                return this.$store.state.aboutUsPageData;
            },
        },
        async asyncData(context) {
            await context.app.$getDataFromCache(`/wp-json/wp/v2/pages/11`)
                .then((response) => {
                    context.store.dispatch("setAboutUsPageData", response.data.acf);
                });
            await context.store.dispatch("setPageChangeAnimationValueFalse");
        },
    };
